import { useUIStore } from '@/stores';
import './BaseGameSetup.css';

type GameMode = 'solo' | 'local' | 'online';

interface BaseGameSetupProps {
  mode: GameMode;
  title: string;
  description: string;
  children: React.ReactNode;
}

/**
 * BaseGameSetup - セットアップ画面の共通ベース
 * Solo/Local/Onlineセットアップで共有されるレイアウトとナビゲーション
 */
const BaseGameSetup = ({ title, description, children }: BaseGameSetupProps) => {
  const navigateTo = useUIStore((state) => state.navigateTo);

  const handleBack = () => {
    navigateTo('main_menu');
  };

  return (
    <div className="BaseGameSetup">
      <div className="BaseGameSetup__container">
        {/* ヘッダー */}
        <div className="BaseGameSetup__header">
          <h1 className="BaseGameSetup__title">{title}</h1>
          <p className="BaseGameSetup__description">{description}</p>
        </div>

        {/* コンテンツ（各モード固有の設定） */}
        <div className="BaseGameSetup__content">{children}</div>

        {/* フッター（戻るボタン） */}
        <div className="BaseGameSetup__footer">
          <button className="BaseGameSetup__back-button" onClick={handleBack}>
            ← メインメニューに戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default BaseGameSetup;
